var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                    " + _vm._s(_vm.heading) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "is-two-thirds column is-paddingless"
  }, [_c('h2', {
    staticClass: "subtitle is-4"
  }, [_vm._v(_vm._s(_vm.subheading))])])])])]), _vm._v(" "), _vm._m(0)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns pd is-desktop"
  }, [_c('div', {
    staticClass: "column is-one-quarter-desktop"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/ISAlogo200px.png"),
      "alt": "ISA"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds-desktop info"
  }, [_c('h3', [_vm._v("Speakers:")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://www.eeecs.qub.ac.uk/~c.decampos/",
      "target": "_blank"
    }
  }, [_vm._v("Cassio P. de Campos")]), _vm._v(", Reader with the Centre for Data Science and Scalable Computing, Queen's University Belfast")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://people.idsia.ch/~alessandro/"
    }
  }, [_vm._v("Alessandro Antonucci")]), _vm._v(", Senior Researcher, Swiss AI Lab IDSIA")])]), _vm._v(" "), _c('h3', [_vm._v("Course description:")]), _vm._v(" "), _c('p', [_vm._v("\n                        Probabilistic models usually need a sharp estimate of their parameters in order to represent a (single) distribution, even if a precise elicitation might be unreliable because of limited expert knowledge, or observations might be scarce, incomplete and/or noisy. Instead, one may resort to sets of probability distributions to represent their knowledge, adopting the so-called theory of imprecise probability. During this tutorial we introduce the main concepts of such methods and present a number of techniques based on it that are designed to cope with uncertainty in a principled robust manner and to yield reliable results. We discuss on robust decision making and sensitivity analysis. Applications in computer vision, pattern recognition and decision support in knowledge-based expert systems are also provided.\n                        "), _c('br'), _c('br'), _vm._v("\n                        The course will consist of four lectures. Tea/coffee breaks and lunch are included in the registration fee.\n                        "), _c('br'), _vm._v("\n                        You can register by e-mailing "), _c('a', {
    attrs: {
      "href": "mailto:wyseja@tcd.ie"
    }
  }, [_vm._v("wyseja@tcd.ie")]), _vm._v(".\n                        "), _c('br'), _c('br'), _vm._v("\n                        The course is sponsored by the "), _c('a', {
    attrs: {
      "href": "http://www.istat.ie/drupal/",
      "target": "_blank"
    }
  }, [_vm._v("Irish Statistical Association")]), _vm._v(".\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns pd is-multiline is-desktop"
  }, [_c('div', {
    staticClass: "column is-one-third-desktop"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Venue of the event")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.google.ie/maps/place/O'Callaghan+Mont+Clare+Hotel/@53.3414972,-6.2530017,17z/data=!3m1!4b1!4m5!3m4!1s0x48670e90db4a8129:0xcf06339f781c38e2!8m2!3d53.341494!4d-6.250813",
      "target": "_blank"
    }
  }, [_vm._v("\n                                O'Callaghan Mont Clare Hotel"), _c('br'), _vm._v("\n                                1-4 Merrion Street Lower, Dublin 2\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Registration fees")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-vcentered"
  }, [_c('i', {
    staticClass: "fa fa-eur",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Student €20, full €30"), _c('br'), _vm._v("\n                            Discount for ISA members 50%\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds-desktop"
  }, [_c('div', {
    staticClass: "card schedule"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Schedule of events")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Tuesday, 14th of November, 2017")]), _vm._v(" "), _c('ul', {
    staticClass: "subtitle is-vcentered"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("9:00 am - 9:30 am:")]), _vm._v(" Register")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("9:30 am - 10:30 am:")]), _vm._v(" Lecture 1")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("10:30 am - 10:45 am:")]), _vm._v(" Coffee break")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("10:45 am - 11:45 am:")]), _vm._v(" Lecture 2")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("11:45 am - 12:45 am:")]), _vm._v(" Lunch")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("12:45 am - 13:45 am:")]), _vm._v(" Lecture 3")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("13:45 am - 14:00 am:")]), _vm._v(" Coffee break")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("14:00 am - 15:00 am:")]), _vm._v(" Lecture 4")])])])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13d19230","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Isa.vue
// module id = 9C2f
// module chunks = 0